/**
 *  @class
 *  @function ScrollingContent
 */
if (!customElements.get('scrolling-content')) {
  class ScrollingContent extends HTMLElement {
    static get observedAttributes() {
      return ['selected-index'];
    }

    constructor() {
      super();
      this._cachedHeaderHeight = 0;
    }

    connectedCallback() {
      this.images = Array.from(this.querySelectorAll('.scrolling-content--image'));
      this.first_image = this.querySelector('.scrolling-content--image.active');
      this.sections = Array.from(this.querySelectorAll('.scrolling-content--content'));
      this.header = this.querySelector('.scrolling-content--header');
      this.body = this.querySelector('.scrolling-content--body');
      this.dots = this.first_image ? this.first_image.querySelectorAll('.dot') : [];
      this.offset = '-50% 0% -50% 0%';
      this.selectedIndex = this.selectedIndex;
      this.images_content = [];
      this.intersectionOptions = {
        rootMargin: this.offset,
        threshold: 0
      };

      this._onResize = this.handleResize.bind(this);
      this._onScroll = this.syncHeaderPush.bind(this);
      this.handleResize();
      window.addEventListener('resize', this._onResize, { passive: true });
      window.addEventListener('scroll', this._onScroll, { passive: true });

      this.images.forEach((image, i) => {
        this.images_content[i] = image.querySelector('.scrolling-content--image-inner').innerHTML;
      });

      this.sections.forEach((section) => {
        let observer = new IntersectionObserver(
          this.handleIntersectionCallback.bind(this),
          this.intersectionOptions
        );
        observer.observe(section);
      });

      if (this.dots.length) {
        const host = this;
        let sections = this.sections;
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', function () {
            let h_height = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
            let p_height = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--product-position-height'), 10) || 0;
            let s_height = parseInt(getComputedStyle(host).getPropertyValue('--scrolling-header-height'), 10) || 0;
            let scrollTop = sections[i].getBoundingClientRect().top + window.scrollY - h_height - p_height - s_height;
            window.scrollTo({
              top: scrollTop,
              left: 0,
              behavior: "smooth"
            });
          });
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('scroll', this._onScroll);
    }

    handleResize() {
      this.setScrollingHeaderHeight();
      this.syncHeaderPush();
    }

    isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    setScrollingHeaderHeight() {
      if (!this.header || !this.isDesktop()) {
        this._cachedHeaderHeight = 0;
        this.style.setProperty('--scrolling-header-height', '0px');
        return;
      }
      this.header.style.top = '';
      this._cachedHeaderHeight = this.header.offsetHeight;
      this.style.setProperty('--scrolling-header-height', `${this._cachedHeaderHeight}px`);
    }

    getStackTop() {
      const root = getComputedStyle(document.documentElement);
      const hasStickyHeader = !!document.querySelector('.header-sticky--active');
      const h_height = hasStickyHeader ? (parseInt(root.getPropertyValue('--header-height'), 10) || 0) : 0;
      const p_height = parseInt(root.getPropertyValue('--product-position-height'), 10) || 0;
      return h_height + p_height;
    }

    getImageReleaseLine() {
      const headerHeight = this._cachedHeaderHeight || (this.header ? this.header.offsetHeight : 0);
      const imageHeight = this.first_image ? this.first_image.offsetHeight : 0;
      return this.getStackTop() + headerHeight + imageHeight;
    }

    syncHeaderPush() {
      if (!this.header) return;

      if (!this.isDesktop() || !this.body || !this.first_image) {
        this.header.style.top = '';
        return;
      }

      const baseTop = this.getStackTop();
      const releaseLine = this.getImageReleaseLine();
      const bodyBottom = this.body.getBoundingClientRect().bottom;

      // 图文开始被推走后，同步上移标题 top，让大标题跟着一起滚走
      if (bodyBottom < releaseLine) {
        const past = releaseLine - bodyBottom;
        this.header.style.top = `${baseTop - past}px`;
      } else {
        this.header.style.top = '';
      }
    }

    handleIntersectionCallback(entries) {
      entries.forEach((entry) => {
        let index = this.sections.indexOf(entry.target);
        if (index !== this.selectedIndex) {
          this.selectedIndex = index;
          this.first_image.querySelector('.scrolling-content--image-inner').innerHTML = this.images_content[index];
        }
      });
    }

    get selectedIndex() {
      return parseInt(this.getAttribute('selected-index')) || 0;
    }
    set selectedIndex(index) {
      this.setAttribute('selected-index', index);
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "selected-index" && oldValue !== null && oldValue !== newValue) {
        if (this.dots.length) {
          [].forEach.call(this.dots, function (el) {
            el.classList.remove('is-selected');
          });
          this.dots[newValue].classList.add('is-selected');
        }
      }
    }
  }
  customElements.define('scrolling-content', ScrollingContent);
}
